import Icon from '../components/Icon.vue'

Icon.register({
  'project-diagram': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M384 320c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-128c-17.7 0-32-14.3-32-32v-128c0-17.7 14.3-32 32-32h128zM192 32v32h224v64h-224v47.5l64.3 112.5h-0.3c-23.6 0-44 13-55.1 32l-73.2-128h-95.7c-17.7 0-32-14.3-32-32v-128c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32zM608 0c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-128c-17.7 0-32-14.3-32-32v-128c0-17.7 14.3-32 32-32h128z'
      }
    ]
  }
})
